export default __webpack_public_path__ + "static/media/ly.2dde683b.svg";